import { standardRequestWithErrorFlash } from '../../../shared/utils/request';
import { Agreement } from 'candidate_profile_redesign/shared/types';
import type { Dispatch, State } from '../use_candidate_profile';
import { withLocalePrefix } from '../../../shared/utils/translation';

type DeleteAgreement = {
  type: 'deleteAgreement';
  payload: { id: number };
};

const t = withLocalePrefix(
  'candidate_profile_redesign.application_details.agreement_documents'
);

export const deleteAgreement =
  (_state: State, dispatch: Dispatch) => async (agreement: Agreement) => {
    await standardRequestWithErrorFlash.delete(agreement.deletePath, {
      successMessage: t('modal.success'),
      errorMessage: t('modal.error'),
    });

    dispatch({
      type: 'deleteAgreement',
      payload: { id: agreement.id },
    });
  };

type AddAgreement = {
  type: 'addAgreement';
  payload: Agreement;
};

export const addAgreement =
  (_state: State, dispatch: Dispatch) => (agreement: Agreement) => {
    dispatch({
      type: 'addAgreement',
      payload: agreement,
    });
  };

type AddAgreements = {
  type: 'addAgreements';
  payload: Agreement[];
};

export const getAgreements =
  (state: State, dispatch: Dispatch) =>
  async (useLoading = true) => {
    const {
      paths: { getAgreementsPath },
      currentUser: {
        permissions: { canRequestEsignature },
      },
    } = state;

    if (!canRequestEsignature) {
      dispatch({
        type: 'setStatus',
        payload: { key: 'agreements', type: 'complete' },
      });
      dispatch({
        type: 'addAgreements',
        payload: [],
      });

      return;
    }

    try {
      if (useLoading) {
        dispatch({
          type: 'setStatus',
          payload: { key: 'agreements', type: 'loading' },
        });
      }

      const result = await standardRequestWithErrorFlash.get(getAgreementsPath);

      dispatch({
        type: 'addAgreements',
        payload: result.data.agreements,
      });
    } catch (e: unknown) {
      dispatch({
        type: 'setStatus',
        payload: { key: 'agreements', type: 'error', context: e },
      });
    } finally {
      dispatch({
        type: 'setStatus',
        payload: { key: 'agreements', type: 'complete' },
      });
    }
  };

export type Actions = DeleteAgreement | AddAgreement | AddAgreements;
